import moment from "moment";

export const DateBetween = (dateone, datetwo) => {
  const diff = moment(datetwo).diff(moment(dateone), "days");
  return diff === 0 ? 1 : diff + 1;
};

export const isStepActive = (step, order, statuses = []) =>
  step?.order === order && statuses.includes(step?.status);

// export const isStepActive = (steps = [], order, statuses = []) => {
//   const step = steps.find(item => item?.order === order);
//   return !!step && statuses.includes(step.status);
// };
